export default function () {
  let window = `relatorio.leiloes.outros`
  !this.$uloc.window.get(window) && this.$uloc.window.new({
    wid: window,
    title: 'Outros Relatórios de Leilões',
    width: '600',
    height: '450',
    minHeight: '500px',
    backdrop: false,
    maximize: false,
    clickOutside: false,
    windowClass: 'erp-window',
    contentClass: 'overflow-hidden',
    props: {
    }
  }, () => import('./Outros.vue'))
    .then((wid) => {
      console.log(wid)
    }) // return wid
}
